import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant, ImageConstant } from "const";
import { PageTitle, PaperHeader } from "components";
import { useBranchDetails } from "hooks";
import { CompanyProfile } from "./components";
import { SystemUtils } from "utils";

const CompanyManagement = () => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });
  const CompanyProfileIcon = ImageConstant.CompanyProfileIcon;

  const { branchDetails, isLoading: isLoadingBranchDetails } = useBranchDetails();

  useEffect(() => {
    SystemUtils.openCircleLoading(Boolean(isLoadingBranchDetails));
  }, [isLoadingBranchDetails]);

  return (
    <Fragment>
      <PageTitle>{titleObjectContent.companyProfile}</PageTitle>
      <div className="card" style={{ padding: 30, margin: "30px 0", borderRadius: 4 }}>
        <div className="card-body" style={{ padding: 0 }}>
          <PaperHeader icon={<CompanyProfileIcon />} title={getLabel(LangConstant.TXT_COMPANY_PROFILE)} />
          <CompanyProfile branchDetails={branchDetails} />
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyManagement;
